export const USER_SETTING_HAS_ENABLED_ZOOM_AUTOLOG = 'hasEnabledZoomAutolog';
export const USER_SETTING_HAS_ENABLED_GOOGLE_MEET_AUTOLOG = 'hasEnabledGoogleMeetAutolog';
export const USER_SETTING_HAS_ALLOWED_GOOGLE_MEET_WEBHOOK_PROCESSING =
    'hasAllowedGoogleMeetWebhookProcessing';
export const USER_SETTING_HAS_ENABLED_MICROSOFT_TEAMS_AUTOLOG = 'hasEnabledMicrosoftTeamsAutolog';
export const USER_SETTING_HAS_ENABLED_AIRCALL_AUTOLOG = 'hasEnabledAircallAutolog';
export const USER_SETTING_HAS_ENABLED_CALLRAIL_AUTOLOG = 'hasEnabledCallRailAutolog';
export const USER_SETTING_HAS_ENABLED_RINGCENTRAL_AUTOLOG = 'hasEnabledRingCentralAutolog';
export const USER_SETTING_HAS_ENABLED_DIALPAD_AUTOLOG = 'hasEnabledDialpadAutolog';
export const USER_SETTING_HAS_ENABLED_KIXIE_AUTOLOG = 'hasEnabledKixieAutolog';

export const LOG_MODE_MANUAL = 'manual';
export const LOG_MODE_AUTOLOG = 'autolog';
export type LogMode = typeof LOG_MODE_MANUAL | typeof LOG_MODE_AUTOLOG;

export const TAB_UNLOGGED = 'unlogged-meetings';
export const TAB_LOGGED = 'logged-meetings';
export const TAB_SETTINGS = 'settings';

export type ActiveTab = typeof TAB_UNLOGGED | typeof TAB_LOGGED | typeof TAB_SETTINGS;
